export default "__VITE_ASSET__BhPzZBjN__"